'use es6';

import sortBy from 'transmute/sortBy';
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
export const getLatestGenericChannelUsed = genericChannels => {
  const hasGenericChannels = genericChannels && genericChannels.size > 0;
  if (!hasGenericChannels) return null;
  return sortBy(getTimestamp, genericChannels).last();
};